// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"589a221e","269":"4497ce3a","512":"7376c02d","552":"b1240b49","660":"70c02c26","679":"483d59b5","688":"73404514","781":"0cec23dd","818":"c9b2513b"}[chunkId] + ".chunk.js";
};